import { render, staticRenderFns } from "./SubscriptionReviews.vue?vue&type=template&id=5fb31fad&scoped=true"
import script from "./SubscriptionReviews.vue?vue&type=script&lang=js"
export * from "./SubscriptionReviews.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionReviews.vue?vue&type=style&index=0&id=5fb31fad&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb31fad",
  null
  
)

export default component.exports